.VerifiedButton {
  .VerifiedButton-Btn {
    --btn-icon-size: var(--semantics-icon-sm);
  }

  svg {
    path {
      fill: var(--semantic-colors-typography-inverse);
    }
  }
}